module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ca-AD.json
// module id = 1463
// module chunks = 22